import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewBranches = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/common?table=branch`, data);
  return res.data;
};
export const getAllBranches = async () => {
  const res = await axios.get(`${API_BASE_URL}/branches`);
  return res.data;
};
export const getBranchesById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/branches/${id}`);
  return res.data;
};
